<script setup lang="ts">
import { generateTranslationKey } from '~/utilities/data-transformers';

withDefaults(
  defineProps<{
    showTitle: boolean;
    showSubTitle: boolean;
    formTitle?: string;
    titleClasses?: { [key: string]: boolean }[];
    formSubTitle?: string;
    subTitleClasses?: { [key: string]: boolean }[];
  }>(),
  {
    showTitle: false,
    showSubTitle: false,
    formTitle: '',
    titleClasses: null,
    formSubTitle: '',
    subTitleClasses: null,
  },
);
const site = useSiteStore();
</script>
<template>
  <div>
    <p
      v-if="showTitle && !!formTitle"
      :class="titleClasses"
      v-html="
        $t(
          generateTranslationKey(`title.${formTitle}-${site.getRegionCode}`),
          generateTranslationKey(`title.${formTitle}`),
        )
      "
    />
    <p
      v-if="showSubTitle && !!formSubTitle"
      :class="subTitleClasses"
      v-html="
        $t(
          generateTranslationKey(
            `sub-title.${formSubTitle}-${site.getRegionCode}`,
          ),
          generateTranslationKey(`sub-title.${formSubTitle}`),
        )
      "
    />
  </div>
</template>
